/** Station-owned artwork shared by the live hero and persistent player. */
export const LIVE_ARTWORK = '/brand/hgr-live-cover.jpg';
